import {
  ArrowBackIosNew as ArrowBackIosNewIcon,
  ArrowForwardIos as ArrowForwardIosIcon,
} from "@mui/icons-material";
import { Box, Link, Typography } from "@mui/material";
import PropTypes from "prop-types";
import React from "react";
import { Link as RouterLink } from "react-router-dom";
import theme from "utils/theme";

export default function NavHeader({ setIsOpenNav, isOpenNav }) {
  return (
    <Box
      sx={{
        position: "relative",
        height: "40px",
        m: "8px 16px 12px 16px",
        pb: "16px",
        borderBottom: "1px solid #CDD6DC",
      }}
    >
      <Link
        component={RouterLink}
        to="/"
        sx={{
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
          textDecoration: "none",
          color: "#000",
          cursor: "pointer",
        }}
      >
        <Box
          component="img"
          src="/stel.png"
          alt=""
          sx={{ height: 40, width: 40 }}
        />
        <Typography
          variant="h1"
          sx={{
            fontWeight: 400,
            color: theme.colors.grey,
            fontSize: 24,
            overflow: "hidden",
          }}
        >
          Stel
        </Typography>
      </Link>
      {!isOpenNav ? (
        <ArrowForwardIosIcon
          sx={{
            position: "absolute",
            display: "none",
            right: "-30px",
            top: "16px",
            padding: "8px",
            borderRadius: "50%",
            fontSize: 10,
            background: "#fff",
            color: theme.colors.blue,
            zIndex: 5,
            boxShadow:
              "rgb(9 30 66 / 15%) 0px 0px 0px 1px, rgb(9 30 66 / 8%) 0px 2px 0px",
            "&:hover": {
              cursor: "pointer",
              background: theme.colors.blue,
              color: "#fff",
            },
          }}
          onClick={() => setIsOpenNav(true)}
        />
      ) : (
        <ArrowBackIosNewIcon
          sx={{
            position: "absolute",
            display: "none",
            right: "-30px",
            top: "16px",
            padding: "8px",
            borderRadius: "50%",
            fontSize: 10,
            background: "#fff",
            color: theme.colors.blue,
            zIndex: 5,
            boxShadow:
              "rgb(9 30 66 / 15%) 0px 0px 0px 1px, rgb(9 30 66 / 8%) 0px 2px 0px",
            "&:hover": {
              cursor: "pointer",
              background: theme.colors.blue,
              color: "#fff",
            },
          }}
          onClick={() => setIsOpenNav(false)}
        />
      )}
    </Box>
  );
}
NavHeader.propTypes = {
  setIsOpenNav: PropTypes.func.isRequired,
  isOpenNav: PropTypes.bool,
};
NavHeader.defaultProps = {
  isOpenNav: false,
};
